import { useTranslation } from "react-migration/lib/i18n/useTranslation";
export const ImpersonationBanner = () => {
  const { t } = useTranslation();
  return (
    <div
      id="impersonation-banner"
      className="fixed bottom-10 left-1/2 max-w-auto p-2 px-8 -translate-x-1/2 bg-warning-400 text-warning-800 z-1 rounded-full flex flex-col items-center"
      data-testid="overdue-invoice-banner"
    >
      <strong>{t("nav.you_are_running_in_impersonation_mode")}</strong>
      <span>{t("nav.logout_to_return_to_your_normal_account")}</span>
    </div>
  );
};
